// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.I3d9dnAV5WUE0lqT {
  color: #303030;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 40px;
  margin-top: 0;
}

.ukW5DXFYYvcEse98 {
  display: inline-block;
  margin-inline: 6px;
}

.p5byOzCUfIVtftDB {
  margin-bottom: 40px;
}

.C37M7FO2fFoTbmTA {
  color: #303030;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 16px;
  margin-top: 0;
}

.IF0CN4ErbAKlT5O8,
.pw7CGUQHmwEi8Ur0 {
  width: 100%;
  height: 48px;
  padding: 8px 16px;
  border-radius: 16px;
  border: none;
  font-size: 14px;
  color: #303030;
  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);
}

.pw7CGUQHmwEi8Ur0 {
  background-color: #e0dcd7;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
}

.JIGz_vdRNUXmj85p {
  width: 32px;
  height: 32px;
  background-color: transparent;
  border: none;
}

.JIGz_vdRNUXmj85p span::before {
  color: #4d87be;
}

.m9gcUnuTwDsfKyMS {
  display: flex;
  gap: 56px;
  margin-bottom: 72px;
}

.m9gcUnuTwDsfKyMS .C37M7FO2fFoTbmTA {
  margin-bottom: 24px;
}

.vcmjcQbEOFU5TlYX {
  padding-left: 15px;
}

.vcmjcQbEOFU5TlYX li {
  font-size: 14px;
  color: #303030;
  margin-bottom: 16px;
}

.vcmjcQbEOFU5TlYX,
.vcmjcQbEOFU5TlYX li:last-child {
  margin-bottom: 0;
  margin-top: 0;
}

.ep2a6wsbQgRBn3II {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.oicWGR812rAiiWEj {
  display: flex;
  align-items: center;
  gap: 8px;
}

.oicWGR812rAiiWEj label {
  font-size: 14px;
  color: #303030;
}

.tFTGH3OjHo8KkU6X {
  width: 16px;
  height: 16px;
}

.tFTGH3OjHo8KkU6X .p-radiobutton-box {
  width: 16px;
  height: 16px;
  border-radius: 9999px;
  border: 2px solid #d9d9d9;
  background-color: #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tFTGH3OjHo8KkU6X .p-radiobutton-box .p-radiobutton-icon {
  width: 12px !important;
  height: 12px;
  border-radius: 9999px;
  background-color: #303030;
}

.i7IPRrYDdQQH0UhG {
  font-size: 14px;
  color: rgba(48, 48, 48, 0.8);
  font-style: italic;
  font-weight: 300;
  margin-block: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Chef/components/SendStationStatisticModal/components/SendStationModalContent/SendStationModalContent.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".subtitle {\r\n  color: #303030;\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  margin-bottom: 40px;\r\n  margin-top: 0;\r\n}\r\n\r\n.dot {\r\n  display: inline-block;\r\n  margin-inline: 6px;\r\n}\r\n\r\n.formSection {\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.sectionTitle {\r\n  color: #303030;\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  margin-bottom: 16px;\r\n  margin-top: 0;\r\n}\r\n\r\n.emailInput,\r\n.emailReadonly {\r\n  width: 100%;\r\n  height: 48px;\r\n  padding: 8px 16px;\r\n  border-radius: 16px;\r\n  border: none;\r\n  font-size: 14px;\r\n  color: #303030;\r\n  box-shadow: 2px 7px 18px 3px rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.emailReadonly {\r\n  background-color: #e0dcd7;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  background-color: #fff;\r\n}\r\n\r\n.editEmailBtn {\r\n  width: 32px;\r\n  height: 32px;\r\n  background-color: transparent;\r\n  border: none;\r\n}\r\n\r\n.editEmailBtn span::before {\r\n  color: #4d87be;\r\n}\r\n\r\n.mainContentSection {\r\n  display: flex;\r\n  gap: 56px;\r\n  margin-bottom: 72px;\r\n}\r\n\r\n.mainContentSection .sectionTitle {\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.reportList {\r\n  padding-left: 15px;\r\n}\r\n\r\n.reportList li {\r\n  font-size: 14px;\r\n  color: #303030;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.reportList,\r\n.reportList li:last-child {\r\n  margin-bottom: 0;\r\n  margin-top: 0;\r\n}\r\n\r\n.radioButtons {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n.radioRow {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.radioRow label {\r\n  font-size: 14px;\r\n  color: #303030;\r\n}\r\n\r\n.radioButton {\r\n  width: 16px;\r\n  height: 16px;\r\n}\r\n\r\n.radioButton :global(.p-radiobutton-box) {\r\n  width: 16px;\r\n  height: 16px;\r\n  border-radius: 9999px;\r\n  border: 2px solid #d9d9d9;\r\n  background-color: #d9d9d9;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.radioButton :global(.p-radiobutton-box .p-radiobutton-icon) {\r\n  width: 12px !important;\r\n  height: 12px;\r\n  border-radius: 9999px;\r\n  background-color: #303030;\r\n}\r\n\r\n.formatHint {\r\n  font-size: 14px;\r\n  color: rgba(48, 48, 48, 0.8);\r\n  font-style: italic;\r\n  font-weight: 300;\r\n  margin-block: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var subtitle = `I3d9dnAV5WUE0lqT`;
export var dot = `ukW5DXFYYvcEse98`;
export var formSection = `p5byOzCUfIVtftDB`;
export var sectionTitle = `C37M7FO2fFoTbmTA`;
export var emailInput = `IF0CN4ErbAKlT5O8`;
export var emailReadonly = `pw7CGUQHmwEi8Ur0`;
export var editEmailBtn = `JIGz_vdRNUXmj85p`;
export var mainContentSection = `m9gcUnuTwDsfKyMS`;
export var reportList = `vcmjcQbEOFU5TlYX`;
export var radioButtons = `ep2a6wsbQgRBn3II`;
export var radioRow = `oicWGR812rAiiWEj`;
export var radioButton = `tFTGH3OjHo8KkU6X`;
export var formatHint = `i7IPRrYDdQQH0UhG`;
export default ___CSS_LOADER_EXPORT___;
